import { createUseStyles } from 'react-jss';

export const SpeechToInsightsStyle = createUseStyles({
    errorMessage: {
        color: 'red',
        fontWeight: 'bold',
    },
    layout: {
        background: 'white',
        padding: '24px',
        paddingTop: 0,
    },
    tabs: {
        height: '100%',
    },
});
